import { DetailedHTMLProps, HTMLAttributes, useState } from "react";

type Args = {
  onDrop: (files: FileList) => void;
};

type Return = Pick<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  "onDragEnter" | "onDragLeave" | "onDragOver" | "onDrop"
> & {
  isDraggedOver: boolean;
};

const useDragAndDropFile = ({ onDrop: handleDrop }: Args): Return => {
  const [isDraggedOver, setIsDraggedOver] = useState<boolean>(false);

  const onDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggedOver(false); // Reset drag over state

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      handleDrop(files);
    }
  };

  const onDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggedOver(true);
  };

  const onDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggedOver(false);
  };

  const onDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggedOver(true);
  };

  return {
    isDraggedOver,
    onDragEnter,
    onDragLeave,
    onDragOver,
    onDrop
  };
};

export default useDragAndDropFile;
